import { COMMON_ACTIONS } from "../thunks/common.thunk";

interface CommonSliceProps {
  history: string[];
  session_id: string | null;
  articleList: any[];
  selectedArticle?: any;
}

const initialState: CommonSliceProps = {
  history: [],
  session_id: null,
  articleList: [],
  selectedArticle: null,
};

export default function commonReducer(state = initialState, action: any) {
  switch (action.type) {
    case COMMON_ACTIONS.SET_HISTORY:
      let temp: any = state.history;
      const index = temp.indexOf(action.payload);
      if (index === -1) {
        temp.push(action.payload);
      } else {
        temp.splice(index + 1);
      }

      state = {
        ...state,
        history: temp,
      };

      return state;

    case COMMON_ACTIONS.RESET_HISTORY:
      state = {
        ...state,
        history: [],
      };

      return state;

    case COMMON_ACTIONS.SET_ARTICLE_LIST:
      return {
        ...state,
        articleList: action.payload,
      };

    case COMMON_ACTIONS.SET_SELECTED_ARTICLE:
      return {
        ...state,
        selectedArticle: action.payload,
      };

    case COMMON_ACTIONS.SET_SESSION_ID:
      return {
        ...state,
        session_id: action.payload,
      };

    default:
      return state;
  }
}
